import CreateNotificationForm from '@/components/forms/CreateNotificationForm.vue';
import { OrganizationRole } from '@/enums/roles';
import AdminOverview from '@/views/admin/AdminOverview.vue';
import OrganizationSources from '@/views/sources/OrganizationSources.vue';
import Teams from '@/views/teams/Teams.vue';
import type { RouteRecordRaw } from 'vue-router';

const routes: readonly RouteRecordRaw[] = [
    {
        path: '/beheer',
        name: 'admin',
        component: AdminOverview,
        meta: {
            pageTitle: 'Beheer',
            roles: [OrganizationRole.Admin]
        }
    },

    {
        path: '/beheer/teams',
        name: 'admin-teams',
        component: Teams,
        meta: {
            pageTitle: 'Beheer | Teams',
            roles: [OrganizationRole.Admin]
        }
    },
    {
        path: '/beheer/notificatie-aanmaken',
        name: 'admin-notifications-create',
        component: CreateNotificationForm,
        meta: {
            pageTitle: 'Beheer | Notificatie aanmaken',
            roles: [OrganizationRole.Admin]
        }
    },
    {
        path: '/beheer/bronnen/:organizationId',
        name: 'organization-sources',
        component: OrganizationSources,
        meta: {
            pageTitle: `Bronnen`,
            roles: [OrganizationRole.Admin]
        }
    }
];

export default routes;
